// extracted by mini-css-extract-plugin
export default {"p_content":"_8584ade7b3"};